module.exports = "<div class=nn-addon-youtube><div><div id=\"youtube-player{{ youtubeSettings.item.content }}\"></div></div></div>"


//////////////////
// WEBPACK FOOTER
// ./app/components/nn-add-ons/nn-addon-youtube/nn-addon-youtube.directive.html
// module id = 948
// module chunks = 0